import { makeStyles } from 'tss-react/mui';

const useStylesFilteredLink: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  filteredLink: {
    color: theme.palette.secondary.main,
    textDecoration: 'none !important',
    fontWeight: 500,
  },
  filteredLinkSwitcher: {
    textDecoration: 'underline dashed !important',
    cursor: 'pointer',
  },
  filteredLinkDownload: {
    position: 'relative',
    top: -5,
    '& svg': {
      position: 'relative',
      top: 7,
    },
  },
  filteredLinkBlack: {
    color: theme.palette.common.black,
  },
}));

export default useStylesFilteredLink;
